module.exports = ".menu-side-v2-w ul.main-menu > li .icon-w {\n    color: #0073ff;\n    font-size: 27px;\n    display: block;\n    padding: 1rem;\n    width: 70px;\n    text-align: center;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n}\n.icon-w.test > div{\n    color: rebeccapurple;\n}\n.icon-w.local > div{\n    color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/sidebar/sidebar.component.css
// module id = ./src/app/_layout/sidebar/sidebar.component.css
// module chunks = main